import http from './http'
import qs from 'qs'
import { serialize } from 'object-to-formdata';

export default {
    all(query = {}) {
        return http.get('cursos?' + qs.stringify(query))
    },

    get(curso) {
        return http.get(`cursos/${curso}`)
    },

    evaluaciones(query = {}) {
        return http.get('cursos-evaluaciones?' + qs.stringify(query));
    },

    create(payload) {

        const formData = serialize(payload, {
            nullsAsUndefineds: true,
            booleansAsIntegers: true,
        })

        return http.post('cursos', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json'
            }
        })
    },

    update(curso, payload) { 
        const formData = serialize(payload, {
            nullsAsUndefineds: true,
            booleansAsIntegers: true,
        })


        // Necesario para subir archivos por peticion PUT
        // En caso contrario no enviara nada en el cuerpo
        // Y hacer una peticion POST
        formData.append("_method", 'PUT')

        return http.post(`cursos/${curso}`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Accept': 'application/json'
            }
        })
    },

    delete(curso) {
        return http.delete(`cursos/${curso}`)
    },

    restore(curso) {
        return http.put(`cursos/${curso}`)
    },

    save({ id, ...payload }) {
        if (id) {
            return this.update(id, payload);
        }

        return this.create({ id, ...payload })
    }
}